export default "__VITE_PUBLIC_ASSET__bbebccb1__"